import React, { useMemo } from 'react';

import styled from 'styled-components';

import { useCompanyProfile } from '@aqx-core/common/services/company';
import { EAppThemeMode, useAppTheme } from '@aqx-core/common/theme';

interface IUICompanyLogoProps {
  allowedMode?: EAppThemeMode[];
}

const UICompanyLogo: FCC<IUICompanyLogoProps> = (props) => {
  const { allowedMode: allowMode = [EAppThemeMode.LIGHT, EAppThemeMode.DARK] } = props;

  const { logoPath, logoDarkThemePath } = useCompanyProfile() || {};

  const {
    theme: { themeMode }
  } = useAppTheme();

  const logo = useMemo(() => {
    // Handle case when no modes are allowed
    if (!allowMode.length) {
      return null;
    }
    // Handle single mode case
    if (allowMode.length === 1) {
      switch (allowMode[0]) {
        case EAppThemeMode.DARK:
          return logoDarkThemePath;
        case EAppThemeMode.LIGHT:
          return logoPath;
        default:
          return null;
      }
    }
    // Handle multiple modes case
    if (!allowMode.includes(themeMode)) {
      return null;
    }

    return themeMode === EAppThemeMode.DARK ? logoDarkThemePath : logoPath;
  }, [allowMode, logoDarkThemePath, logoPath, themeMode]);

  if (!logo) {
    return <></>;
  }

  return <StyledLogo src={logo && `/${logo}`} alt="COMPANY_LOGO" />;
};

export default UICompanyLogo;

const StyledLogo = styled.img`
  width: 100%;
  height: auto;
`;
